import { React } from 'react'
import PropTypes from 'prop-types'
import '../../../scss/ReactAutosuggestWithReactstrap.css'
import Autosuggest from 'react-autosuggest'

const AutosuggestComponent = ({
  style,
  input_style,
  label,
  placeholder,
  name,
  value = "",
  hidden,
  disabled,
  required,
  display,
  suggestions,
  onSuggestionsFetchRequested,
  onSuggestionSelected,
  onSuggestionsClearRequested,
  onChange,
  onBlur,
}) => {
  const renderSuggestion = (suggestion) => {
    return <span>{suggestion.value}</span>
  }
  const getSuggestionValue = (suggestion1) => suggestion1.value
  const inputProps = {
    placeholder: 'Search ' + placeholder,
    value: value || "",
    onChange: onChange,
    onBlur: onBlur,
    required: required, 
    //autoFocus: true
  }
  if (hidden) return null;
  return (
    <>
      {display
        ?
        <div className={`${style}`} >
          {label !== "" &&
            <label htmlFor={name} className="form-label" >
              {required && <span className="text-danger"> * </span>}{label}
            </label>
          }
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            onSuggestionSelected={onSuggestionSelected}
            renderSuggestion={renderSuggestion}
            inputProps={{
              ...inputProps,
              className: 'form-control autosuggest-input', // ensure Bootstrap styling and your own
            }}
            // theme={{
            //   container: 'autosuggest-container',
            //   input: 'autosuggest-input',
            //   suggestionsContainer: 'autosuggest-suggestions-container',
            //   suggestionsList: 'autosuggest-suggestions-list',
            //   suggestion: 'autosuggest-suggestion',
            // }}
          />
        </div>
        :
        <div className={`${style}`} >
          <div className="flex">
            {label !== "" &&
              <div className={`col-md-3`} >
                <label
                  className="form-label"
                  htmlFor={name}
                >
                  {required && <span className="text-danger"> * </span>}{label}
                </label>
              </div>
            }
            <div className={`col-md-9`} >
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                onSuggestionSelected={onSuggestionSelected}
                renderSuggestion={renderSuggestion}
                inputProps={{
                  ...inputProps,
                  className: 'form-control autosuggest-input', // ensure Bootstrap styling and your own
                }}
                // theme={{
            //   container: 'autosuggest-container',
            //   input: 'autosuggest-input',
            //   suggestionsContainer: 'autosuggest-suggestions-container',
            //   suggestionsList: 'autosuggest-suggestions-list',
            //   suggestion: 'autosuggest-suggestion',
            // }}
              />
            </div>
          </div>
        </div>
      }
    </>
  )
}

AutosuggestComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  suggestions: PropTypes.func.isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
}

export default AutosuggestComponent
